<template>
  <div>
    <vue-headful :title="pageTitle"/>
    <v-container fluid>
      <h1>
        <v-layout>
          <span>{{title}}</span>
          <v-spacer></v-spacer>
          <span :class="results.attestationStatus === 'Аттестован' ? 'green--text' : 'red--text'">{{ results.attestationStatus }}</span>
          <v-btn class="mr-0" color="primary" @click="toPdf">Печать</v-btn>
        </v-layout>
      </h1>
      <table class="results">
        <tr>
          <th class="results__stage">Этап</th>
          <th class="results__count">Кол-во баллов</th>
          <th class="results__max">Максимальное кол-во баллов</th>
        </tr>
        <tr>
          <td>Тестирование</td>
          <td>{{resultsTestBall}}</td>
          <td>{{results.test.length}}</td>
        </tr>
        <tr>
          <td>Тематические вопросы</td>
          <td>{{resultsThematicBall}}</td>
          <td>{{results.thematic.length * 10}}</td>
        </tr>
        <tr>
          <td>Практические задачи</td>
          <td>{{resultsPracticeBall}}</td>
          <td>{{results.practice.length * 20}}</td>
        </tr>
        <tr>
          <td><strong>Итого</strong></td>
          <td><strong>{{total}}</strong></td>
          <td><strong>{{totalMax}}</strong></td>
        </tr>
      </table>
      <br>
      <h2>Тестирование</h2>
      <data-table :items="results.test" :headers="headers">
        <tr slot-scope="props" :class="backTestAnswer(props.item.ball)">
          <td class="text-xs-center">{{ props.index + 1 }}</td>
          <td>{{ props.item.questionText }}</td>
          <td>{{ props.item.answerText }}</td>
          <td class="text-xs-center">{{ props.item.ball }}</td>
        </tr>
      </data-table>
      <h2>Тематические вопросы</h2>
      <data-table :items="results.thematic" :headers="headers">
        <tr slot-scope="props" :class="backThematicAnswer(props.item.ball)">
          <td class="text-xs-center">{{ props.index + 1 }}</td>
          <td v-html="props.item.questionText"></td>
          <td v-html="props.item.answerText"></td>
          <td class="text-xs-center">{{ props.item.ball }}</td>
        </tr>
      </data-table>
      <h2>Практические задачи</h2>
      <data-table :items="results.practice" :headers="headers">
        <tr slot-scope="props" :class="backPracticeAnswer(props.item.ball)">
          <td class="text-xs-center">{{ props.index + 1 }}</td>
          <td v-html="props.item.questionText"></td>
          <td v-html="props.item.answerText"></td>
          <td class="text-xs-center">{{ props.item.ball }}</td>
        </tr>
      </data-table>
    </v-container>
  </div>
</template>

<script>
import AttestationService from '@/services/AttestationService'
import SettingsService from '@/services/SettingsService'
import DataTable from '@/components/fragments/DataTable'

export default {
  components: {DataTable},
  props: {
    id: String
  },
  data: () => ({
    title: 'Результат',
    headers: [
      {text: '№', align: 'center', sortable: false, width: 30},
      {text: 'Текст вопроса', align: 'center', sortable: false},
      {text: 'Текст ответа', align: 'center', sortable: false},
      {text: 'Балл', align: 'center', sortable: false, width: 30}
    ],
    results: {
      status: '',
      attestationStatus: '',
      test: [{id: '', questionText: '', ball: '', answerText: ''}],
      thematic: [{id: '', questionText: '', ball: '', answerText: '', attestationStatus: ''}],
      practice: [{id: '', questionText: '', ball: '', answerText: '', attestationStatus: ''}]
    },
    attestationService: undefined
  }),
  computed: {
    pageTitle () {
      return SettingsService.pageTitle(this.title)
    },
    resultsTestBall () {
      let balls = 0
      this.results.test.forEach(item => {
        balls += item.ball
      })
      return balls
    },
    resultsThematicBall () {
      let balls = 0
      this.results.thematic.forEach(item => {
        balls += item.ball
      })
      return balls
    },
    resultsPracticeBall () {
      let balls = 0
      this.results.practice.forEach(item => {
        balls += item.ball
      })
      return balls
    },
    total () {
      return this.resultsTestBall + this.resultsThematicBall + this.resultsPracticeBall
    },
    totalMax () {
      return this.results.test.length + this.results.thematic.length * 10 + this.results.practice.length * 20
    }
  },
  methods: {
    toPdf () {
      this.attestationService.resultToPdf(this.id, blob => {
        this.fileUrl = URL.createObjectURL(blob)
        window.open(process.env.SITE_URL + '/pdf/view?link=' + this.fileUrl)
        window.focus()
      })
    },
    backTestAnswer (ball) {
      return ball > 0 ? 'green-back-answer' : 'red-back-answer'
    },
    backThematicAnswer (ball) {
      switch (ball) {
        case 0 :
          return 'red-back-answer'
        case 5:
          return 'yellow-back-answer'
        case 10:
          return 'green-back-answer'
        default:
          return ''
      }
    },
    backPracticeAnswer (ball) {
      switch (ball) {
        case 0 :
          return 'red-back-answer'
        case 10:
          return 'yellow-back-answer'
        case 20:
          return 'green-back-answer'
        default:
          return ''
      }
    }
  },
  created () {
    this.attestationService = new AttestationService(this.$store)
    this.attestationService.getStudentAttestationInfoById(this.id, (data) => {
      if (!data.status) this.$router.replace({name: 'ErrorNotFound'})
      if (data.test.length < 50) this.$router.push('/attestation/test')
      else if (data.thematic.length < 3) this.$router.push('/attestation/thematic')
      else if (data.practice.length < 2) this.$router.push('/attestation/practice')
      else this.results = data
    })
  }
}
</script>

<style lang="scss" scoped>
h2 {
  text-align: center;
}

.results {
  border: 1px solid #8E8E8E;
  width: 100%;
  text-align: center;
  border-spacing: 0;

  th, td {
    border: 1px solid #8E8E8E;
    padding: 5px 10px;
  }
}

.green-back-answer {
  background: rgba(0, 255, 0, 0.05);
}

.green-back-answer:nth-child(2n) {
  background: rgba(0, 255, 0, 0.085);
}

.yellow-back-answer {
  border-radius: 8px;
  background: rgba(255, 255, 0, 0.25);
}

.yellow-back-answer:nth-child(2n) {
  border-radius: 8px;
  background: rgba(255, 255, 0, 0.35);
}

.red-back-answer {
  background: rgba(255, 0, 0, 0.05);
}

.red-back-answer:nth-child(2n) {
  background: rgba(255, 0, 0, 0.085);
}

.green-back-answer, .red-back-answer {
  td {
    padding: 5px !important;
  }
}

.results__count, .results__max {
  width: 33.33%;
}
</style>



// WEBPACK FOOTER //
// src/pages/admin/attesation_info/student/Result.vue